import React from "react";
import { Link, useLocation } from "react-router-dom";
import Fan1Logo from "../../assets/img/logo.png";

const Footer: React.FC = () => {
  const location = useLocation();
  const isTermsOrPrivacyPage = location.pathname === "/terms" || location.pathname === "/privacy" || location.pathname === "/codeofconduct" || location.pathname === "/notableuserterms" || location.pathname === "/emailresubscribe";
  const isHomePage = location.pathname === '/';

  return (
    <footer>
      <div className="div-home-footer bg-midnight container position-relative p-5">
        <div className="d-flex flex-column flex-lg-row mobile-items">
          <div className="col-12 col-lg-4 d-flex justify-content-start mb-3 mb-lg-0">
            <figure>
              <img
                src={Fan1Logo}
                alt="Logo"
                className="img-fluid logo-width mb-3"
              />
            </figure>
          </div>

          <div className="d-flex flex-column flex-lg-row w-100">
            <div className="col-12 col-lg-3 mb-3 mb-lg-0 d-lg-flex justify-content-start">
              <div>
                <h3 className="font-500-20">Are you a fan?</h3>
                <ul>
                  <li className="font-400-15">
                    <Link
                      to="/fans"
                      className="font-400-15 text-decoration-none color-Light-Purple"
                    >
                      Go to Fan Page{" "}
                      <span>
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-12 col-lg-3 mb-3 mb-lg-0 d-lg-flex justify-content-end">
              <div>
                <h3 className="font-500-20">Want to list on Fan1?</h3>
                <ul>
                  <li className="font-400-15">
                    <Link
                      to="/famous"
                      className="font-400-15 text-decoration-none color-Light-Purple"
                    >
                      Go to Famous Page{" "}
                      <span>
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-12 col-lg-3 mb-3 mb-lg-0 d-lg-flex justify-content-end">
              <div>
                <h5 className="font-500-20">Resources</h5>
                <ul>
                  {/* <li className="nav-link">
                    <Link
                      to="/help"
                      className="nav-link font-300-15 text-decoration-none"
                    >
                      Help
                    </Link>
                  </li> */}
                  <li className="nav-link">
                    <Link
                      to="/learn"
                      className="nav-link font-300-15 text-decoration-none"
                    >
                      Learn
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-12 col-lg-3 mb-lg-0 d-lg-flex justify-content-end me-2">
              <div>
                <h5 className="font-500-20">Company</h5>
                <ul>
                  {/* <li className="nav-link">
                    <Link
                      to="/"
                      className="nav-link font-300-15 text-decoration-none"
                    >
                      About
                    </Link>
                  </li> */}
                   <li className="nav-link">
                    <Link
                      to="/contact"
                      className="nav-link font-300-15 text-decoration-none"
                    >
                      Contact
                    </Link>
                  </li>
                  {/* <li className="nav-link">
                    <a
                      href="mailto:hey@fan1.us"
                      className="nav-link text-decoration-none font-300-15"
                    >
                      Contact
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="mt-3 header-search font-300-10 line-13">
            <div className="justify-content-md-end mt-3 mt-md-0">
              <span
                className="font-300-15 me-3 text-white d-block"
              >
                <Link
                  to="/codeofconduct"
                  className="text-decoration-none text-white"
                >
                  Code of Conduct
                </Link>
              </span>
              <span
                className="font-300-15 me-3 my-2 text-white d-block"
              >
                <Link
                  to="/terms"
                  className="text-decoration-none text-white"
                >
                  Terms of Service
                </Link>
              </span>

              <span
                className="font-300-15 me-3 mb-3 text-white d-block"
              >
                <Link
                  to="/privacy"
                  className="text-decoration-none text-white"
                >
                  Privacy Notice
                </Link>
              </span>
            </div>
            © 2025 Fan1 LLC. All rights reserved. Patent Pending. Fan1 is a
            trademark of Fan1 LLC.
          </div>
        </div>

        {!isTermsOrPrivacyPage && (
          <>
           {isHomePage && <div className="background-ellipse-left"></div>}
            <div className="background-ellipse-right"></div>
          </>
        )}
      </div>

      <div className="d-flex container justify-content-between view-data flex-column flex-md-row containerFoot py-1 mb-4">
        <span className="font-300-10 text-center d-none d-md-inline text-md-start ms-3">
          © 2025 Fan1 LLC. All rights reserved. Patent Pending. Fan1 is a
          trademark of Fan1 LLC.
        </span>
        <div className="d-flex justify-content-center justify-content-md-end mt-3 mt-md-0">
          <span
            className="font-300-10 me-3 d-none d-md-inline text-white"
          >
            <Link
              to="/codeofconduct"
              className="text-decoration-none text-white"
            >
              Code of Conduct
            </Link>
          </span>
          <span
            className="font-300-10 me-3 d-none d-md-inline text-white"
          >
            <Link
              to="/terms"
              className="text-decoration-none text-white"
            >
              Terms of Service
            </Link>
          </span>

          <span
            className="font-300-10 me-3 d-none d-md-inline text-white"
          >
            <Link
              to="/privacy"
              className="text-decoration-none text-white"
            >
              Privacy Notice
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
